export class HttpService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.controller = new AbortController();
    }
    async get(path, params) {
        const request = new Request(this.createUrl(path, params), {
            signal: this.controller.signal
        });
        const timeout = setTimeout(() => this.controller.abort(), 10000);
        return fetch(request).then(response => {
            clearTimeout(timeout);
            return response;
        });
    }
    async post(path, body, params) {
        const request = new Request(this.createUrl(path, params), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            signal: this.controller.signal
        });
        const timeout = setTimeout(() => this.controller.abort(), 10000);
        return fetch(request).then(response => {
            clearTimeout(timeout);
            return response;
        });
    }
    async put(path, body, params) {
        const request = new Request(this.createUrl(path, params), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        return fetch(request);
    }
    async delete(path, params) {
        const request = new Request(this.createUrl(path, params), {
            method: 'DELETE'
        });
        return fetch(request);
    }
    createUrl(path, params) {
        if (params) {
            path += `?${params}`;
        }
        return new URL(path, this.baseUrl).toString();
    }
}
